import { render, staticRenderFns } from "./HeaderUsuario.vue?vue&type=template&id=1a32ced5"
import script from "./HeaderUsuario.vue?vue&type=script&lang=js"
export * from "./HeaderUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports